var map = {
	"./about.js": 7412,
	"./banners.js": 4907,
	"./catalog.js": 6673,
	"./companies.js": 8407,
	"./customers.js": 4466,
	"./favorites.js": 6979,
	"./forgot-password.js": 8925,
	"./help.js": 6756,
	"./invitation.js": 547,
	"./login.js": 8266,
	"./messages.js": 9081,
	"./myApp.js": 1454,
	"./orders.js": 4303,
	"./products.js": 6856,
	"./profile.js": 4570,
	"./reset-password.js": 8714,
	"./shopping-cart.js": 4092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2157;